import { render, staticRenderFns } from "./minimize.vue?vue&type=template&id=b966022a&scoped=true"
import script from "./minimize.vue?vue&type=script&lang=js"
export * from "./minimize.vue?vue&type=script&lang=js"
import style0 from "./minimize.vue?vue&type=style&index=0&id=b966022a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b966022a",
  null
  
)

export default component.exports